import { generateSlug } from '~/lib/slugify';
import type { Client } from '~/types/models';

type ClientSlugSource = Partial<Client> & {
    businessName?: string;
};

export function resolveClientBusinessName(client: ClientSlugSource): string {
    return String(
        client.companyName
        || client.businessName
        || client.name
        || client.contactName
        || '',
    ).trim();
}

export function resolveClientSlug(client: ClientSlugSource): string {
    return generateSlug(resolveClientBusinessName(client)) || 'client';
}

export function normalizeClientSlug(slug: unknown): string {
    return String(slug || '').trim().toLowerCase();
}

export function clientSlugMatches(client: ClientSlugSource, slug: unknown): boolean {
    const normalizedSlug = normalizeClientSlug(slug);
    if (!normalizedSlug) return false;

    return normalizeClientSlug(client.slug) === normalizedSlug
        || resolveClientSlug(client) === normalizedSlug;
}
